import { SECTOR_ANGLES, TARGET_SYMBOLS, timing, variantForLevel, } from './params';
const FEEDBACK_MS = 600;
function pickRandom(arr, n, exclude = []) {
    const pool = arr.filter((x) => !exclude.includes(x));
    const out = [];
    while (out.length < n && pool.length > 0) {
        const i = Math.floor(Math.random() * pool.length);
        out.push(pool.splice(i, 1)[0]);
    }
    return out;
}
export function makeStimulus(trialIdx, durationMs, level) {
    const variant = variantForLevel(level);
    const targetSymbol = TARGET_SYMBOLS[Math.floor(Math.random() * TARGET_SYMBOLS.length)];
    const targetAngle = SECTOR_ANGLES[Math.floor(Math.random() * SECTOR_ANGLES.length)];
    const distractorAngles = pickRandom(SECTOR_ANGLES, variant.nDistractors, [targetAngle]);
    const distractorSymbols = [];
    for (let i = 0; i < distractorAngles.length; i += 1) {
        if (variant.hardDistractors) {
            // Symbole aléatoire (peut être identique au target pour ambiguïté)
            distractorSymbols.push(TARGET_SYMBOLS[Math.floor(Math.random() * TARGET_SYMBOLS.length)]);
        }
        else {
            // Symbole strictement différent du target (pop-out simplifié)
            const others = TARGET_SYMBOLS.filter((s) => s !== targetSymbol);
            distractorSymbols.push(others[Math.floor(Math.random() * others.length)]);
        }
    }
    return {
        trialIdx,
        durationMs: Math.max(timing.minRenderMs, durationMs),
        targetSymbol,
        targetAngle,
        distractorAngles,
        distractorSymbols,
    };
}
export function createHawkEyeAdapter(level = 1) {
    let state = {
        subPhase: 'idle',
        stim: null,
        feedback: null,
        level,
        variant: variantForLevel(level),
    };
    const listeners = new Set();
    let resolver = null;
    let rejecter = null;
    let trialStart = 0;
    const timers = [];
    function clearTimers() {
        while (timers.length > 0) {
            const t = timers.pop();
            if (t !== undefined)
                clearTimeout(t);
        }
    }
    function update(patch) {
        state = { ...state, ...patch };
        for (const l of listeners) {
            try {
                l(state);
            }
            catch {
                /* ignored */
            }
        }
    }
    return {
        mount() { },
        unmount() {
            clearTimers();
            listeners.clear();
            if (rejecter) {
                rejecter(new Error('unmount'));
                rejecter = null;
                resolver = null;
            }
        },
        presentStimulus(stim) {
            clearTimers();
            return new Promise((resolve, reject) => {
                resolver = resolve;
                rejecter = reject;
                update({ subPhase: 'fixation', stim, feedback: null });
                timers.push(setTimeout(() => {
                    update({ subPhase: 'stimulus' });
                    trialStart = Date.now();
                    timers.push(setTimeout(() => {
                        update({ subPhase: 'mask' });
                        timers.push(setTimeout(() => {
                            update({ subPhase: 'awaiting_response' });
                        }, timing.maskMs));
                    }, stim.durationMs));
                }, timing.fixationMs));
            });
        },
        async showFeedback(correct) {
            update({ subPhase: 'feedback', feedback: correct ? 'correct' : 'incorrect' });
            await new Promise((resolve) => {
                timers.push(setTimeout(() => {
                    update({ subPhase: 'iti' });
                    resolve();
                }, FEEDBACK_MS));
            });
        },
        pause() { },
        resume() { },
        abort() {
            clearTimers();
            if (rejecter) {
                rejecter(new Error('aborted'));
                rejecter = null;
                resolver = null;
            }
        },
        getState() {
            return state;
        },
        subscribe(listener) {
            listeners.add(listener);
            listener(state);
            return () => {
                listeners.delete(listener);
            };
        },
        handleSectorPick(angle) {
            if (state.subPhase !== 'awaiting_response')
                return;
            const stim = state.stim;
            if (!stim)
                return;
            const correct = angle === stim.targetAngle;
            const rt = Date.now() - trialStart;
            const resp = { pickAngle: angle, correct, reactionTimeMs: rt };
            if (resolver) {
                const r = resolver;
                resolver = null;
                rejecter = null;
                r(resp);
            }
        },
        setLevel(newLevel) {
            const v = variantForLevel(newLevel);
            update({ level: newLevel, variant: v });
        },
    };
}
export function radiusForVariant(variant) {
    const map = {
        '10deg': 90,
        '20deg': 130,
        '30deg': 160,
    };
    return map[variant.eccentricity] ?? 130;
}
//# sourceMappingURL=adapter.js.map